<div class="modal-body">
  <h5 class="text-primary">
    Are you still there?
    You will be logged out in <strong>{{displayTime}}</strong> unless you respond.
  </h5>
  <p>
    <button type="button" bkButton (click)="onCancel()">I'm still here</button>
  </p>
</div>
